export function loadGoogleFont(fontFamily: string) {
  const fontName = fontFamily.split(",")[0].replace(/['"]/g, "").trim();
  if (!fontName) return;

  const linkId = `qc-font-${fontName.replace(/\s+/g, "-").toLowerCase()}`;
  if (document.getElementById(linkId)) return;

  const link = document.createElement("link");
  link.id = linkId;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontName)}:wght@100;200;300;400;500;600;700;800;900&display=swap`;
  document.head.appendChild(link);
}
